import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import { DropInQueueService } from './dropin-queue.service';

export class DropInQueueInterface {
	constructor(private queueContext: DropInQueueService, private translateService: TranslateService) {}

	/**
	 *
	 * Update Queuedata
	 */
	queueData() {
		if (typeof this.queueContext.queue.data === 'undefined') return false;

		this.countdown('start', 'queuedata', this.queueContext.queue.data.openStatus.estimatedQueueTime);
	}

	stopQueueCountdownTimer() {
		this.countdown('stop', 'queuedata', null);
	}

	/**
	 * Countdown
	 */
	countdown(action: string, name: string, timeLeft: number) {
		var ti = timeLeft;
		if (action === 'start') {
			clearInterval(this[name]);
			this[name] = window.setInterval(() => {
				if (this.queueContext.room === null) return;

				ti--;
				let minutes = Math.floor(ti / 60);
				var text = minutes + ' ' + this.translateService.get('Common.Abbreviation.MinutesShort');
				if (ti < this.queueContext.room.roomInfo.MinimumShownWaitTime + 1)
					text = '< ' + Math.floor(this.queueContext.room.roomInfo.MinimumShownWaitTime / 60);
				else if (minutes > 59)
					text =
						Math.floor(minutes / 60) +
						this.translateService.get('Common.Abbreviation.Hours') +
						' ' +
						(minutes % 60) +
						this.translateService.get('Common.Word.Minutes');

				this.queueContext.queue.waitTimeString = text;

				if (ti < 1) clearInterval(this[name]);
			}, 1000);
		} else if (action === 'stop') {
			clearInterval(this[name]);
		}
	}
}
